import Papa from 'papaparse';
import * as XLSX from 'xlsx'

type SpreadsheetParseResult<T> = {
    data: T[][];
    errors: Record<string, any>[];
    meta: Record<string, any>;
};

// Helper function to normalize the sheet data
const normalizeSheetData = (rows: any[][]): string[][] => {
    return rows
        .filter(row => Array.isArray(row) && row.some(cell => cell !== null && cell !== undefined && String(cell).trim() !== ''))
        .map(row => row.map(cell => cell === null || cell === undefined ? '' : String(cell)))
}

// Helper function to parse csv files
export const parseSpreadsheet = (file: File): Promise<SpreadsheetParseResult<string>> => {
    return new Promise((resolve, reject) => {

        // Get the name of the file
        const file_name = file.name.toLowerCase()

        // Handle parsing of a csv file
        if (file_name.endsWith('.csv')) {
            const reader = new FileReader();

            reader.onload = (event) => {
                if (event.target?.result) {
                    const content = event.target.result as string;

                    Papa.parse(content, {
                        header: false,
                        skipEmptyLines: true,
                        complete: (result: SpreadsheetParseResult<string>) => {
                            resolve({
                                // data: result.data as string[][],
                                data: normalizeSheetData(result.data as any[][]),
                                errors: result.errors || [],
                                meta: result.meta || {},
                            });
                        },
                        error: (error: unknown) => reject(error),
                    });
                }
            };

            reader.onerror = (error) => reject(error);
            reader.readAsText(file);
            return
        }

        // Handle parsing of an xls or xlsx file
        if (file_name.endsWith('.xlsx') || file_name.endsWith('.xls')) {
            const reader = new FileReader()

            reader.onload = event => {
                if (event.target?.result) {
                    try {
                        const array_buffer = event.target.result as ArrayBuffer
                        const workbook = XLSX.read(array_buffer, { type: 'array' })
                        const first_sheet_name = workbook.SheetNames[0]
                        const worksheet = workbook.Sheets[first_sheet_name]
                        const rows = XLSX.utils.sheet_to_json(worksheet, {
                            header: 1,
                            raw: false,  // Important: prevents 100 -> 100.0 issues
                            defval: '',
                        }) as any[][]

                        resolve({
                            data: normalizeSheetData(rows),
                            errors: [],
                            meta: { sheetName: first_sheet_name },
                        })
                    } catch (error) {
                        reject(error)
                    }
                }
            }

            reader.onerror = error => reject(error)
            reader.readAsArrayBuffer(file)
            return
        }

        reject(new Error('Unsupported file type'))
    })
};